import axios from 'axios';
import { createClient } from '@supabase/supabase-js';

// Create Supabase client
const supabaseUrl = process.env.VUE_APP_SUPABASE_URL;
const supabaseKey = process.env.VUE_APP_SUPABASE_KEY;
export const supabase = createClient(supabaseUrl, supabaseKey);

// Create Axios instance
const axiosInstance = axios.create({
  baseURL: process.env.VUE_APP_API_URL,
  timeout: 10000,
  headers: {
    'Content-Type': 'application/json',
  },
  withCredentials: false
});

// Request interceptor - to add auth token
axiosInstance.interceptors.request.use(
  async (config) => {
    // Add authentication token
    const { data } = await supabase.auth.getSession();
    if (data?.session?.access_token) {
      config.headers.Authorization = `Bearer ${data.session.access_token}`;
    }
    
    return config;
  },
  (error) => {
    return Promise.reject(error);
  }
);

// Add response interceptor
axiosInstance.interceptors.response.use(
  (response) => {
    return response;
  },
  (error) => {
    // Handle CORS errors
    if (error.code === 'ERR_NETWORK' || error.message.includes('Network Error')) {
      console.error('CORS error occurred:', error);
      // Return a user-friendly error message
      return Promise.reject({
        message: 'Error connecting to the server. Please try again.'
      });
    }
    
    return Promise.reject(error);
  }
);

export default axiosInstance;
